// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"6e2f7e4d","840":"288a82fc","854":"3e489fdf"}[chunkId] + ".css";
};